import React from 'react';
import {usePersistentQueryParam} from "../hooks";

import TeamHomePageSelector from '../team-home-page/TeamSelector'
import TeamHomePageRouter from '../team-home-page/index'

export default () => {
  const [teamId,setTeamId,clearTeamId] = usePersistentQueryParam('teamId')

  if (teamId) {
    return <TeamHomePageRouter teamId={parseInt(teamId)} clearTeamId={clearTeamId} />
  } else {
    return <TeamHomePageSelector setTeamId={setTeamId} />
  }
}
